import type { QueryApi } from "../../api/query";

export function createUseProjectStatistics($api: QueryApi) {
  return function useProjectStatistics(projectId: string) {
    return $api.useQuery(
      "get",
      "/projects/{id}/statistics",
      { params: { path: { id: projectId } } },
      { enabled: !!projectId, staleTime: 5 * 60_000 },
    );
  };
}
